import React from 'react';
import PropTypes from 'prop-types';

const Initials = props => {
  const { name } = props;
  const initials = name && name.split(' ').slice(0, 2).map(word => word.charAt(0)).join('')
    .toUpperCase();

  return <React.Fragment>{initials}</React.Fragment>;
};

Initials.propTypes = {
  name: PropTypes.string,
};

export default Initials;
